import type { AuthView } from "~/features/auth/AuthOverlay";

export const OPEN_AUTH_OVERLAY = "OPEN_AUTH_OVERLAY";
export const CLOSE_AUTH_OVERLAY = "CLOSE_AUTH_OVERLAY";

type RegisterState = {
  isOpen: boolean;
  view: AuthView;
  initialEmail: string;
  alternativeGAAction?: string;
  alternativeLoginRedirectUrl?: string;
};

const initialState: RegisterState = {
  isOpen: false,
  view: "register",
  initialEmail: "",
};

export interface OpenAuthOverlayPayload {
  view: AuthView;
  initialEmail?: string;
  alternativeGAAction?: string;
  alternativeLoginRedirectUrl?: string;
}

type Action = { type: typeof OPEN_AUTH_OVERLAY; payload: OpenAuthOverlayPayload } | { type: typeof CLOSE_AUTH_OVERLAY };

export const authOverlayReducer = (state = initialState, action: Action): RegisterState => {
  switch (action.type) {
    case OPEN_AUTH_OVERLAY:
      return {
        ...state,
        isOpen: true,
        view: action.payload.view,
        initialEmail: action.payload.initialEmail ?? "",
        alternativeGAAction: action.payload.alternativeGAAction,
        alternativeLoginRedirectUrl: action.payload.alternativeLoginRedirectUrl,
      };

    case CLOSE_AUTH_OVERLAY:
      return {
        ...state,
        isOpen: false,
      };

    default:
      return state;
  }
};
